import { render } from "./AddAdmissionsApplication.vue?vue&type=template&id=7c7b8ff1&scoped=true&ts=true"
import script from "./AddAdmissionsApplication.vue?vue&type=script&lang=ts"
export * from "./AddAdmissionsApplication.vue?vue&type=script&lang=ts"

import "./AddAdmissionsApplication.vue?vue&type=style&index=0&id=7c7b8ff1&lang=css&scoped=true"
import "./AddAdmissionsApplication.vue?vue&type=style&index=1&id=7c7b8ff1&lang=css"
import "./AddAdmissionsApplication.vue?vue&type=style&index=2&id=7c7b8ff1&scoped=true&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7b8ff1"]])

export default __exports__